<template>
  <div class="page">
    <div class="title">
      <h1 class="h1title" v-parallax.absY="-0.9">{{title}}</h1>
      <h1 class="h1title" v-parallax.absY="1.2">{{title}}</h1>

      <i v-for="ball in ballPos" :style="ball.style" v-parallax.centerX="ball.parallax"></i>
    </div>

    <my-content></my-content>
  </div>
</template>

<script>
import Content from './content'

export default {
  name: 'hello',
  components: {
    'my-content': Content
  },
  data () {
    return {
      title: 'vue-parallax-js'
    }
  },
  computed: {
    ballPos() {
      let rnd = (max) => Math.round(Math.random() * max)
      let r = [];
      let circs = window.innerWidth / 20;
      if (circs < 30) circs = 30;

      for (let i = 0; i < circs; i++) {
        let par = (Math.random()*2);
        let size = (0 + (2 * par)).toFixed(2);
        let left = (rnd(80) + 10);
        let top = (rnd(40) + 30);
        // let top = 50

        if (Math.random() < 0.5) {
          par = par * -1
        }

        r.push ({
          style: {
            left: left + '%',
            top: top + '%',
            width: size + 'vw',
            height: size + 'vw'
          },
          parallax: (par).toFixed(2)
        });
      }
      return r
    }
  }
}
</script>

<style lang="sass">
body
  margin: 0
  padding: 0
  font-size: 1.2em
  letter-spacing: 0.03em
  font-family: sans-serif

.title
  width: 100%
  height: 90vh
  min-height: 400px
  overflow: hidden
  position: relative
  // margin-top: 5000px
  // background-size: cover
  background: #000;
  background-position: center

i
  position: absolute
  z-index: 20
  width: 40px
  height: 40px
  border-radius: 50%
  background-color: #7929a7
  opacity: 0.2

.h1title
  position: absolute
  top: 0
  right: 0
  width: 100%
  text-align: center
  margin: 0 auto
  z-index: 50
  display: block
  opacity: 0.8
  // font-weight: normal
  // font-family: serif
  // text-transform: uppercase
  font-size: 8vw
  line-height: 90vh
  backface-visibility: hidden
  text-shadow: 0 0 120px #000
  color: #7929a7
  // background: #000


  &:first-child
    user-select: none
    pointer-events: none
    clip-path: polygon(0% 0%, 100% 0, 100% 30%, -65% 100%, 0% 100%);

  &:nth-child(2)
    clip-path: polygon(100% 0%, 100% 100%, -65% 100%, 100% 30%);
    // background: red

</style>



// WEBPACK FOOTER //
// ParallaxDemo.vue?30d7f530